<template>
    <div class="dashboard-container">
        <!-- Snackbar -->
        <v-snackbar v-model="snackbar" top :color="color" :timeout="6000">
            <span v-if="snackbar_msg">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <!-- Learner Selection -->
        <v-row justify="center" class="mt-6" max-width="1000">
            <v-col cols="12" md="6">
                <v-autocomplete v-model="selected_learner" :items="learners" item-text="name" item-value="id"
                    label="Select Learner" multiple outlined dense clearable hide-details @change="loadChartData"
                    :placeholder="selected_learner.length === 0 ? 'All Learners' : ''"></v-autocomplete>
            </v-col>
        </v-row>

        <!-- Charts Section -->
        <v-container class="mt-8">
            <v-row justify="center" align="stretch" class="chart-section">

                <!-- 🟣 Student Profile Chart -->
                <v-col cols="12" md="10" class="mb-8">
                    <v-row class="pa-4 rounded-xl elevation-1">
                        <v-skeleton-loader v-if="loading" type="image" />
                        <chart v-else-if="student_profile_chart.series[0].data.length" class="chart" auto-resize
                            :options="student_profile_chart" />
                        <div v-else class="no-data">No Student Profile Data Available.</div>
                    </v-row>
                </v-col>

                <!-- 🟣 Cumulative Profile Chart -->
                <v-col cols="12" md="10" class="mb-8">
                    <v-row class="pa-4 rounded-xl elevation-1">
                        <v-skeleton-loader v-if="loading" type="image" />
                        <chart v-else-if="cumulative_profile_chart.series[0].data.length" class="chart" auto-resize
                            :options="cumulative_profile_chart" />
                        <div v-else class="no-data">No Cumulative Profile Data Available.</div>
                    </v-row>
                </v-col>

                <!-- 🟡 Skill Analysis Chart -->
                <v-col cols="12" md="10" class="mb-8" v-if="skillData!=null">
                    <v-row class="pa-4 rounded-xl elevation-1" >
                        <v-skeleton-loader v-if="loading" type="image" />
                        <chart v-else-if="skill_analysis_chart.series[0].data.length" class="chart" auto-resize
                            :options="skill_analysis_chart" />
                        <!-- <div v-else class="no-data">No Skill Analysis Data Available.</div> -->
                    </v-row>
                </v-col>

                <!-- 🟢 Interest Analysis Chart -->
                <v-col cols="12" md="10" class="mb-8" v-if="interestData!=null">
                    <v-row class="pa-4 rounded-xl elevation-1">
                        <v-skeleton-loader v-if="loading" type="image" />
                        <chart v-else-if="interest_analysis_chart.series[0].data.length" class="chart" auto-resize
                            :options="interest_analysis_chart" />
                        <!-- <div v-else class="no-data">No Interest Analysis Data Available.</div> -->
                    </v-row>
                </v-col>

                <!-- 🔵 Career Analysis Chart -->
                <!-- <v-col cols="12" md="10" class="mb-8">
                    <v-row class="pa-4 rounded-xl elevation-1">
                        <v-skeleton-loader v-if="loading" type="image" />
                        <chart v-else-if="career_analysis_chart.series[0].data.length" class="chart" auto-resize
                            :options="career_analysis_chart" />
                        <div v-else class="no-data">No Career Analysis Data Available.</div>
                    </v-row>
                </v-col> -->

            </v-row>
        </v-container>
    </div>
</template>

<script>
    import axios from "axios";
    import VChart from "vue-echarts";
    import * as echarts from "echarts";

    export default {
        props: ["selected_ay"],
        components: { chart: VChart },
        data() {
            const toolboxConfig = {
                show: true,
                orient: "horizontal",
                feature: {
                    magicType: {
                        show: true,
                        type: ["line", "bar"],
                        title: { line: "Line View", bar: "Bar View" }
                    },
                    dataView: {
                        show: true,
                        readOnly: true,
                        title: "Data View",
                        lang: ["Data View", "Close", "Refresh"] // ✅ fixes Chinese labels
                    },
                    restore: {
                        show: true,
                        title: "Reset Zoom"
                    },
                    saveAsImage: {
                        show: true,
                        title: "Download Image"
                    },
                },
                right: 20,
                top: 5,
            };


            return {
                snackbar: false,
                color: "",
                snackbar_msg: "",
                loading: false,
                selected_learner: [],
                learners: [],
                totalActiveStudents: 0,
                debounceTimer: null,
                pendingChartLoad: false,

                // 🟣 Student Profile Chart (updated tooltip)
                student_profile_chart: {
                    title: { text: "Student Profile", left: "center" },
                    color: ["#4B0082", "#cb7ef8ff"],
                    toolbox: toolboxConfig,
                    tooltip: {
                        trigger: "item",
                        backgroundColor: "#fff",
                        borderColor: "#ccc",
                        borderWidth: 2,
                        textStyle: { color: "#333" },
                        formatter: (params) => {
                            return `<div style='font-weight:bold;'>${params.name}</div>
              ${params.marker} ${params.seriesName}: <b>${params.value}</b>`;
                        },
                    },
                    legend: { bottom: 0, data: ["Awards #", "Student Activity #"], selectedMode: false, },
                    grid: { top: 70, bottom: 60 },
                    xAxis: { type: "category", data: ["Awards #", "Student Activity #"], axisLabel: { rotate: 45 } },
                    yAxis: { type: "value", name: "Count", min: 0 },
                    series: [
                        { name: "Awards #", type: "bar", barWidth: "40%", data: [10, 0], smooth: true,label: { show: true, position: "top" },},
                        { name: "Student Activity #", type: "bar", barWidth: "40%", data: [0, 5] ,  smooth: true, label: { show: true, position: "top" },},
                    ],
                },


                // 🟣 Cumulative Profile Chart (same style)
                cumulative_profile_chart: {
                    title: { text: "Student Profile - Cumulative", left: "center" },
                    color: ["#7DCEA0", "#6BAED6"],
                    toolbox: toolboxConfig,
                    tooltip: { trigger: "axis" },
                    legend: { bottom: 0, data: ["Awards", "Student Activity"], selectedMode: false, },
                    grid: { top: 90, bottom: 90 },
                    xAxis: {
                        type: "category",
                        data: [],
                        axisLabel: { rotate: 45 },
                        nameLocation: "middle",
                        nameGap: 30,
                    },
                    yAxis: { type: "value", name: "Count", min: 0 },
                    series: [
                        { name: "Awards", type: "bar", smooth: true, data: [] ,label: { show: true, position: "top" },},
                        { name: "Student Activity", type: "bar", smooth: true, data: [],label: { show: true, position: "top" }, },
                    ],
                },

                // 🟡 Skill Chart
                skill_analysis_chart: {
                    title: { text: "Student Skill Analysis", left: "center" },
                    color: ["#F8C471"],
                    toolbox: toolboxConfig,
                    tooltip: { trigger: "axis" },
                    grid: { top: 90, bottom: 90 },
                    xAxis: { type: "category", data: [], axisLabel: { rotate: 45 } },
                    yAxis: { type: "value", name: "Count", min: 0 },
                    series: [{ name: "Skills", type: "bar", data: [] ,smooth: true,label: { show: true, position: "top" }, }],
                },

                // 🟢 Interest Chart
                interest_analysis_chart: {
                    title: { text: "Student Interest Analysis", left: "center" },
                    color: ["#6BAED6"],
                    toolbox: toolboxConfig,
                    tooltip: { trigger: "axis" },
                    grid: { top: 90, bottom: 90 },
                    xAxis: { type: "category", data: [], axisLabel: { rotate: 45 } },
                    yAxis: { type: "value", name: "Count", min: 0 },
                    series: [{ name: "Interests", type: "bar", data: [],smooth: true, label: { show: true, position: "top" },}],
                },

                // 🔵 Career Chart
                // career_analysis_chart: {
                //     title: { text: "Student Career Analysis", left: "center" },
                //     color: ["#a9def9"],
                //     toolbox: toolboxConfig,
                //     tooltip: { trigger: "axis" },
                //     grid: { top: 80, bottom: 80 },
                //     xAxis: { type: "category", data: [], axisLabel: { rotate: 45 } },
                //     yAxis: { type: "value", name: "Count", min: 0 },
                //     series: [{ name: "Careers", type: "bar", data: [] }],
                // },
            };
        },

        mounted() {
            if (VChart && VChart.register) {
                try {
                    VChart.register(echarts);
                } catch (e) { }
            }
            if (this.selected_ay) this.loadLearnerList();
        },

        watch: {
            selected_ay(val) {
                if (val) this.loadLearnerList();
            },
            selected_learner() {
                if (this.debounceTimer) clearTimeout(this.debounceTimer);
                this.debounceTimer = setTimeout(() => {
                    if (!this.pendingChartLoad && this.selected_ay) this.loadChartData();
                }, 250);
            },
        },

        methods: {
            showSnackbar(color, msg) {
                this.color = color;
                this.snackbar_msg = msg;
                this.snackbar = true;
            },

            async loadLearnerList() {
                if (!this.selected_ay) {
                    this.showSnackbar("error", "Please select an academic year");
                    return;
                }
                this.loading = true;
                try {
                    const payload = { selected_ay: this.selected_ay, selected_learner: null };
                    const res = await axios.post("/AdminDashboard/getStudentDashboardReport", payload);
                    if (res.data.flag === "YES") {
                        this.learners = (res.data.learner_list || []).map((l) => ({ id: l.id, name: l.name }));
                        if (this.learners.length > 0 && (!this.selected_learner || this.selected_learner.length === 0)) {
                            this.selected_learner = [this.learners[0].id];
                            await this.loadChartData();
                        } else if (this.selected_learner && this.selected_learner.length > 0) {
                            await this.loadChartData();
                        }
                    } else {
                        this.showSnackbar("error", res.data.msg || "No learner data found");
                    }
                } catch (err) {
                    console.error("Error loading learner list:", err);
                    this.showSnackbar("error", "Failed to load learner list");
                } finally {
                    this.loading = false;
                }
            },

            resetAllCharts() {
                const charts = [
                    this.student_profile_chart,
                    this.cumulative_profile_chart,
                    this.skill_analysis_chart,
                    this.interest_analysis_chart,
                    // this.career_analysis_chart,
                ];
                charts.forEach((c) => {
                    if (c.xAxis) c.xAxis.data = [];
                    if (c.series) c.series.forEach((s) => (s.data = []));
                });
            },

            async loadChartData() {
                if (!this.selected_ay) {
                    this.showSnackbar("error", "Please select an academic year");
                    return;
                }
                if (this.pendingChartLoad) return;
                this.pendingChartLoad = true;
                this.loading = true;

                try {
                    const payload = {
                        selected_ay: this.selected_ay,
                        selected_learner:
                            this.selected_learner && this.selected_learner.length > 0 ? this.selected_learner : null,
                    };

                    this.resetAllCharts();
                    this.totalActiveStudents = 0;

                    const res = await axios.post("/AdminDashboard/getStudentDashboardReport", payload);
                    if (res.data.flag !== "YES") {
                        this.showSnackbar("error", res.data.msg || "No chart data found");
                        return;
                    }

                    const data = res.data;

                    // 🟣 Student Profile Data
                    if (data.student_profile) {
                        const profile = data.student_profile;
                        this.student_profile_chart.labels = profile.labels;
                        this.student_profile_chart.series[0].data = [profile.data[0]]; // Awards
                        this.student_profile_chart.series[1].data = [profile.data[1]]; // Student Activity
                    }

                    // 🟣 Cumulative Profile Data
                    const cumulative = data.student_cumulative_profile || [];
                    this.cumulative_profile_chart.xAxis.data = cumulative.map(it => it.academicYear || "");
                    this.cumulative_profile_chart.series[0].data = cumulative.map(it => it.awardsCount || 0);
                    this.cumulative_profile_chart.series[1].data = cumulative.map(it => it.activityCount || 0);


                    // 🟡 Skill Data
                    const skillData = data.student_skill_analysis || [];
                    this.skill_analysis_chart.xAxis.data = skillData.map((it) => it.skill || "Unknown");
                    this.skill_analysis_chart.series[0].data = skillData.map((it) => it.count || 0);

                    // 🟢 Interest Data
                    const interestData = data.student_interest_analysis || [];
                    this.interest_analysis_chart.xAxis.data = interestData.map((it) => it.interest || "Unknown");
                    this.interest_analysis_chart.series[0].data = interestData.map((it) => it.count || 0);

                    // 🔵 Career Data
                    // const careerData = data.student_career_analysis || [];
                    // this.career_analysis_chart.xAxis.data = careerData.map((it) => it.career || "Unknown");
                    // this.career_analysis_chart.series[0].data = careerData.map((it) => it.count || 0);
                } catch (err) {
                    console.error("Error loading chart data:", err);
                    this.showSnackbar("error", "Failed to load chart data");
                } finally {
                    this.loading = false;
                    this.pendingChartLoad = false;
                }
            },
        },
    };
</script>

<style scoped>
    .dashboard-container {
        background-color: #f8fafc;
        min-height: 100vh;
        padding-bottom: 60px;
    }

    .chart {
        width: 100%;
        height: 400px;
        max-width: 980px;
        margin: 0 auto;
    }

    .chart-section {
        margin-top: 20px;
    }

    .no-data {
        text-align: center;
        color: #888;
        font-weight: 500;
        padding: 50px 0;
    }

    .v-autocomplete {
        background: white;
        border-radius: 8px;
    }
</style>